import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../../shared/service/rest.service';
import { Device } from '../model/device';
import { DeviceType } from '../model/device-type';
import { VehicleDisplaySynchronization } from '../model/vehicle-display-synchronization';
import { VehicleDevices } from '../model/vehicle-devices';

@Injectable()
export class DeviceService extends RestService {

  getVehicleDevices(sideNumber: string): Observable<Device[]> {
    return this.doGet<Device[]>(`api/${sideNumber}/devices/all`)
      .pipe(
        map(devs => devs.map(dev => plainToClass(Device, dev)))
      );
  }

  getVehiclesDevices(sideNumbers: string[]): Observable<VehicleDevices[]> {
    return this.doPost<VehicleDevices[]>('api/devices/all', sideNumbers)
      .pipe(
        map(devs => devs.map(dev => plainToClass(VehicleDevices, dev)))
      );
  }

  getDeviceModelsByDeviceType(deviceType: DeviceType): Observable<string[]> {
    return this.doGet<string[]>(`api/devices/${deviceType}/models`);
  }

  getVehicleDisplaySync(sideNumber: string): Observable<VehicleDisplaySynchronization[]> {
    return this.postAndExtract(VehicleDisplaySynchronization, `api/devices/vehicle-display-sync/${sideNumber}`);
  }

}
